export default __webpack_public_path__ + "static/media/CERTORA.0403d907.png";